class FAQ {
  // #QandAs = document.querySelectorAll(`#faqs-2 .question`);
  #parentElement = document.querySelector(".faqs-2-questions");

  constructor() {
    this.addHandlerQuestions();
  }

  addHandlerQuestions() {
    //  guard close is for when user is not in homepage
    if (!this.#parentElement) return;

    this.#parentElement.addEventListener("click", function (e) {
      const btn = e.target.closest(".question");
      const minusIcon = btn.querySelector(".fa-minus").closest("span");
      const plusIcon = btn.querySelector(".fa-plus").closest("span");

      if (!btn) return;

      if (btn.ariaExpanded === "false") {
        plusIcon.classList.remove("d-none");
        minusIcon.classList.add("d-none");
      } else {
        plusIcon.classList.add("d-none");
        minusIcon.classList.remove("d-none");
      }
    });
  }
}

export default new FAQ();
